/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetPublicCaptcha
 */
export interface WidgetPublicCaptcha {
    /**
     * 
     * @type {string}
     * @memberof WidgetPublicCaptcha
     */
    provider: WidgetPublicCaptchaProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof WidgetPublicCaptcha
     */
    siteKey: string;
}


/**
 * @export
 */
export const WidgetPublicCaptchaProviderEnum = {
    Turnstile: 'turnstile'
} as const;
export type WidgetPublicCaptchaProviderEnum = typeof WidgetPublicCaptchaProviderEnum[keyof typeof WidgetPublicCaptchaProviderEnum];


/**
 * Check if a given object implements the WidgetPublicCaptcha interface.
 */
export function instanceOfWidgetPublicCaptcha(value: object): value is WidgetPublicCaptcha {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('siteKey' in value) || value['siteKey'] === undefined) return false;
    return true;
}

export function WidgetPublicCaptchaFromJSON(json: any): WidgetPublicCaptcha {
    return WidgetPublicCaptchaFromJSONTyped(json, false);
}

export function WidgetPublicCaptchaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetPublicCaptcha {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'siteKey': json['siteKey'],
    };
}

export function WidgetPublicCaptchaToJSON(json: any): WidgetPublicCaptcha {
    return WidgetPublicCaptchaToJSONTyped(json, false);
}

export function WidgetPublicCaptchaToJSONTyped(value?: WidgetPublicCaptcha | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': value['provider'],
        'siteKey': value['siteKey'],
    };
}

